import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import api from "@/api/users";
import createCollecte from "./modules/create-collecte";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    client: {},
    token: localStorage.getItem("user-token") || "",
    collecteCollectibles: [],
    dateCreneau: '',
    indexPlanning: 0,
    selectedCreneau: {},
    Tarifs: {},
    gratuit: false,
    fromUpdatePanier: false,
    // AsUser:{nom:'',id_utilisateur:''},
    // currentTab: "FICHE CLIENT",
    // entreprise : {
    //     raison_sociale:"",
    //     actif:true,
    //     code_fta:""
    // }
  },

  getters: {
    getCollecteCollectibles: (state) => {
      return state.collecteCollectibles;
    },
  },

  mutations: {
    infosUser: (state, resp) => {
      state.status = "logged";
      // enregistrement du user dans le state
      state.user = resp.user;
      // stocker dans le local storage le token
      localStorage.setItem("user-token", resp.token);
      axios.defaults.headers.common = { Authorization: `Bearer ${resp.token}` };
    },

    infosClient: (state, resp) => {
      state.client = resp;
    },

    addCollectibles: (state, resp) => {
      state.collecteCollectibles.push(resp);
    },

    dateCreneau: (state, resp) => {
      state.dateCreneau = resp
    },

    indexPlanning: (state, resp) => {
      state.indexPlanning = resp
    },

    deleteCollectible: (state, resp) => {
      state.collecteCollectibles.splice(resp);
    },

    resetState: (state) => {
      state.collecteCollectibles = [];
      state.client = {};
      state.user = {};
    },

    resetCollecte: (state) => {
      state.collecteCollectibles = [];
    },

    updateCollectible: (state, resp) => {
      console.log(resp);
      // state.collecteCollectibles[resp.index].quantity = resp.quantity
      Vue.set(
        state.collecteCollectibles[resp.index],
        "quantity",
        resp.quantity
      );

      state.collecteCollectibles.push("dog-nail");
      state.collecteCollectibles.splice(-1, 1);
    },
    deleteElementCart: (state, resp) => {
      state.collecteCollectibles.splice(resp, 1);
    },
    fillCart: (state, resp) => {
      state.collecteCollectibles = resp
    },
    creneauSelected: (state, resp) => {
      state.selectedCreneau = resp
    },
    isFromUpdatePanier: (state, resp) => {
      state.fromUpdatePanier = resp
    },
    tarifCollecte: (state, resp) => {
      state.Tarifs = resp
    },
    gratuitCollecte: (state, resp) => {
      state.gratuit = resp
    },
  },
  actions: {
    isAuthenticated: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common = {
          Authorization: `Bearer ${localStorage.getItem("user-token")}`,
        };
        api.isAuthenticated().then((res) => {
          if (res.status == 200) {
            commit("infosUser", res.data.data);
          }
          resolve(res)
        }, error => {
          // http failed, let the calling function know that action did not work out
          reject(error)
        });
      })

    },

  },
  modules: {
    createCollecte
  }
});

// on peux supprimer pour moi les dossiers actions,modules et creer un dossier api dans src et y mettre le fichier situé dans utils api.js
